const state = {
  all: []
}

const mutations = {
  addParadasProgramadasList (state, res) {
    state.all.push(res.data)
  },
  clearParadasProgramadasList (state) {
    state.all = []
  },
  updateParadasProgramadasList (state, res) {
    state.all = res.data
  }
}

const actions = {
  clearListParadasProgramadas(context, id) {
    context.commit('clearParadasProgramadasList')
  },
  createParadaProgramada (context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/paradasprogramadas', data).then((res) => {
      context.commit('addParadasProgramadasList', res)
      return res
    })
  },
  updateParadaProgramada (context, data) {
    var id = data.id
    let qs = require('querystring')
    var dados = qs.stringify(data.paradaprogramada)
    return window.axios.put('/api/v2/paradasprogramadas/' + id, dados).then((res) => {
      return res
    })
  },
  deleteParadaProgramada (context, id) {
    return window.axios.delete('/api/v2/paradasprogramadas/' + id).then((res) => {
      return res
    })
  },
  listParadasProgramadas(context, id) {
    return window.axios.get('/api/v2/paradasprogramadas/turno/' + id).then((res) => {
      context.commit('updateParadasProgramadasList', res)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ParadasProgramadas.js